import { useCreateOperator } from '../../../../contexts/CreateOperatorContext';
import { MediaFirstRequired } from './MediaFirstRequired';
import { MediaroomRequired } from './MediaroomRequired';
import React from 'react';

export const RequiredSettings = () => {
  const { operator } = useCreateOperator();

  if (
    operator.mediaRoomSettings === undefined &&
    operator.mediaFirstSettings === undefined
  )
    return null;

  return (
    <section className="flex flex-col gap-2">
      <MediaroomRequired />
      <MediaFirstRequired />
    </section>
  );
};
